import { render, staticRenderFns } from "./loginModal.vue?vue&type=template&id=24edc6bd&scoped=true&"
import script from "./loginModal.vue?vue&type=script&lang=js&"
export * from "./loginModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24edc6bd",
  null
  
)

export default component.exports